export default "https://cdn-gra.amplement.io/statics/images/placeholder/global-placeholder@3x.png";